import React, { Fragment } from "react";
import { ErrorMessage, Field } from "formik";
import Input from "./Input";
import { useTranslation } from "react-i18next";

function AddressForm({
  field,
  addresses,
  setFieldValue,
  isValid,
  isDisabled,
  fetchedFields,
  highlightedFields,
}) {
  const { t } = useTranslation();

  return (
    <Fragment>
      <div className="row mb-3 gx-3">
        <div className="col">
          <label className="form-label" htmlFor={`${field}[0].street`}>
            {t("address.street")}
          </label>
          <div className="input-group">
            <Field
              name={`${field}[0].street`}
              component={Input}
              autoComplete="off"
              disabled={isDisabled && !!fetchedFields?.street}
              className={`form-control fs-13px h-45px ${
                isValid && !!fetchedFields?.street ? "is-valid" : ""
              }${highlightedFields?.street ? " bg-yellow-100 bg-opacity-25" : ""}`}
            />
            <ErrorMessage
              name={`${field}[0].street`}
              render={(msg) => <div className="invalid-feedback">{t(msg)}</div>}
            />
          </div>
        </div>
      </div>
      <div className="row mb-3 gx-3">
        <div className="col-5 col-md-4">
          <label className="form-label" htmlFor={`${field}[0].zip`}>
            {t("address.zip")}
          </label>
          <Field
            component={Input}
            inputMode="numeric"
            autoComplete="off"
            name={`${field}[0].zip`}
            disabled={isDisabled && !!fetchedFields?.zip}
            className={`form-control fs-13px h-45px ${
              isValid && !!fetchedFields?.zip ? "is-valid" : ""
            }${highlightedFields?.zip ? " bg-yellow-100 bg-opacity-25" : ""}`}
            onChange={(e) =>
              setFieldValue(`${field}[0]`, {
                ...addresses[0],
                zip: e.target.value,
              })
            }
          />
          <ErrorMessage
            name={`${field}[0].zip`}
            render={(msg) => <div className="invalid-feedback">{t(msg)}</div>}
          />
        </div>
        <div className="col col-md-8">
          <label className="form-label" htmlFor={`${field}[0].city`}>
            {t("address.city")}
          </label>
          <Field
            component={Input}
            name={`${field}[0].city`}
            disabled={isDisabled && !!fetchedFields?.city}
            autoComplete="off"
            className={`form-control fs-13px h-45px ${
              isValid && !!fetchedFields?.city ? "is-valid" : ""
            }${highlightedFields?.city ? " bg-yellow-100 bg-opacity-25" : ""}`}
            onChange={(e) =>
              setFieldValue(`${field}[0]`, {
                ...addresses[0],
                city: e.target.value,
              })
            }
          />
          <ErrorMessage
            name={`${field}[0].city`}
            render={(msg) => <div className="invalid-feedback">{t(msg)}</div>}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default AddressForm;
